import React, { Component } from 'react'
import { Button , VirtualInput, NumberKeyboard,NavBar,Toast ,TextArea,AutoCenter,Popup, Result} from "antd-mobile";
import ComBlock from '../../components/ComBlock';
import {saveOrder,qureyPayResult,querymchtName} from '../../api'

export class Order extends Component {
  state = {
    merchantCode:undefined,
    merchantName:'',
    tel:'',
    payStatus:'',
    orderNo:'',
    amt:0,
    description:'',
    htmlIfo:'',
    payVisible:false,
    timerCount:10,
  }
  //intervalRef = useRef(null);
  
  back = () =>{
    //   Toast.show({
    //     content: '点击了返回区域',
    //     duration: 1000,
    // })
  }

  onSubmit=()=>{
    const {orderNo,payStatus,amt,merchantCode,description,timerCount}=this.state;
    const param = {
      amt,merchantCode,description
    }
    if(!merchantCode){
      Toast.show({content: "码牌未绑定商户",duration: 3000});
      throw "";
    }
    if(!amt || amt<=0.01 || amt> 99999.99){ 
      Toast.show({content: "请输入有效交易金额0.01-99999元",duration: 3000});
      throw "";
    }else{
      this.setState({payVisible:true,timerCount:10}) 
      saveOrder(param).then((res)=>{
        //this.setState({htmlIfo:res.qrCodeUrl,payVisible:true});
        if(res && res.qrCodeUrl){
          window.location.href=res.qrCodeUrl;
        }
      }); 
    }
    // saveOrder(param).then((result) =>{
    //   console.log('result:',result);
    //   this.setState({htmlIfo:result.qrCodeUrl,payVisible:true});
      // clearInterval(this.timer);
      // let index = 0;
      // this.timer = setInterval(() => {
      //     //循环查询支付结果 
      //     qureyPayResult({ orderNo:orderNo}).then(res=>{
      //     if(res.statusCode==='00'){
      //       this.setState({payStatus:'支付成功',payVisible:false});
      //       clearInterval(this.timer);
      //     }
      //   }); 
      //   index++; 
      // }, 3000);
      // while(this.state.payStatus==='支付成功' || index>20){
      //   clearInterval(this.timer);
      // }
      //   if(payStatus==='支付成功'){
      //     //跳转到支付成功页面
      //     this.props.history.push("/resultPage");
      //   }else{
      //     //跳转返回当前支付页面 
      //     Toast.show({content: "支付错误",duration: 2000});
      //     this.setState({payVisible:false});
      //   } 
      // }).catch(err=>{
      //   console.log("支付错误");
      //   Toast.show({content: err,duration: 2000});
      //   this.setState({payVisible:false});
      // }); 
  }
  componentDidMount(){
    const searchParams = new URLSearchParams(window.location.search);
    const merchantName = searchParams.get('merchantName');
    const merchantCode = searchParams.get('merchantCode');
    //if(!merchantName){
      const param={merchantCode:merchantCode}
      const res = querymchtName(param).then(result=>{
        this.setState({merchantName:result.data.merchantName,merchantCode});
      });
    // }else{
    //   this.setState({merchantName:merchantName,merchantCode});
    // }
   
  }
  render() {
    const {merchantName,payVisible} =this.state;
    return (
      <div >
         <NavBar
          style={{
            '--height': '50px',
            '--border-bottom': '1px #eee solid',
          }}
          // onBack={this.back}
          backArrow={null}
        >
        <AutoCenter>向商户付款</AutoCenter>
        </NavBar>
        <div style={{ "margin-right": "15px",  
                      "padding-top":"20px",
                      "padding-bottom":"25px",
                      //#f1a315
                      "--adm-color-border":'#0395fd',
                      "margin-left":"15px",
                      "background": "linear-gradient(to bottom, rgb(172 213 233 / 47%), #ffffff)",
                      "border-radius": "13px"}}> 
          <div style={{ "font-size": "var(--adm-font-size-main)",
                        "font-family": "var(--adm-font-family)"}}>
            <AutoCenter><div style={{"font-size": "large"}}>{merchantName}</div></AutoCenter>
          </div>
          <div style={{"padding": "5px","margin": "5px"}} >
            <ComBlock title='付款金额' >
            {/* <Divider contentPosition='left'>付款金额：</Divider> */}
            <VirtualInput placeholder='请输入内容' 
              onChange={(val)=>{
                  this.setState({amt:val}) 
              }}
             keyboard={<NumberKeyboard confirmText='确定' customKey={'.'} />}/>
            </ComBlock> 
          </div>
          <div style={{"padding": "5px","margin": "5px"}}>
            {/* <Divider contentPosition='left'>添加备注：</Divider> */}
            <ComBlock title='添加备注'>
              <TextArea
                defaultValue={''}
                showCount
                maxLength={50}
                onChange={(val)=>{
                  this.setState({description:val})
                }}
                />
               </ComBlock>
          </div>
        </div>
        <Button block color="primary" disabled={payVisible} size="large" onClick={this.onSubmit}>付款</Button>
        {/*  <Popup visible={payVisible} showCloseButton >
            <div dangerouslySetInnerHTML={{ __html: htmlIfo}} />  
           <div dangerouslySetInnerHTML={{ __html: 'https://pro.ant.design/zh-CN/docs/overview/'}} /> 
        </Popup> */}
        <div style={{"display":"flex","justifyContent":"center","alignItems":"flex-start"}}>
          <p style={{"marginTop":"90%"}}><a  style={{"fontSize": "11px"}} href="https://beian.miit.gov.cn/" target="_blank">渝ICP备2021006685号-1</a></p>
        </div>
      </div>
    )
  }
}

export default Order
